import React, { useState } from "react";
import { FiStar } from "react-icons/fi"; // Import star icon
import { db } from "../firebase/config"; // Import Firebase database instance (using 'db' export)
import { ref, push, serverTimestamp } from "firebase/database"; // Import Firebase database functions
import { getAuth } from "firebase/auth"; // Import Firebase Auth

const FeedbackForm = ({ onClose }) => {
  // Removed: feedbackType, title, description, stepsToReproduce
  const [content, setContent] = useState(""); // New state for unified content
  const [rating, setRating] = useState(0); // New state for star rating (0 = not rated)
  // const [attachment, setAttachment] = useState(null); // Commented out attachment state
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // null, 'success', 'error'
  const [errorMessage, setErrorMessage] = useState("");

  /* // Commented out attachment handler
  const handleFileChange = (event) => {
    setAttachment(event.target.files[0]);
  };
  */

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    setErrorMessage("");

    // --- Get User ID ---
    const userId = localStorage.getItem("userId"); // Get userId from localStorage

    if (!userId) {
      setErrorMessage("Bạn cần đăng nhập để gửi phản hồi.");
      setIsSubmitting(false);
      setSubmitStatus("error");
      return;
    }

    // --- Updated Basic Validation ---
    if (!content.trim()) {
      setErrorMessage("Vui lòng nhập nội dung phản hồi.");
      setIsSubmitting(false);
      setSubmitStatus("error");
      return;
    }
    // Removed validation for title, description, steps

    // --- Updated Prepare Data ---
    const feedbackData = {
      userId, // Add userId
      content, // Use unified content field
      rating: rating > 0 ? rating : null, // Include rating if selected, use null if not
      // attachment: attachment ? attachment.name : undefined, // Commented out attachment info
      // --- Contextual Data (Remains the same) ---
      context: {
        appVersion: process.env.REACT_APP_VERSION || "N/A",
        userAgent: navigator.userAgent,
        timestamp: serverTimestamp(), // Use Firebase server timestamp
        url: window.location.href,
      },
    };

    console.log("Submitting Feedback to Firebase:", feedbackData);

    // --- Save to Firebase Realtime Database ---
    try {
      const feedbackRef = ref(db, "feedbacks"); // Reference to 'feedbacks' node (using 'db')
      await push(feedbackRef, feedbackData); // Push data to generate unique key

      console.log("Feedback submitted successfully to Firebase.");
      setSubmitStatus("success");
      // Optionally clear form
      // setContent(''); setRating(0); // setAttachment(null); // Keep attachment commented
      // setTimeout(onClose, 2000); // Keep commented or adjust as needed
    } catch (error) {
      console.error("Error submitting feedback to Firebase:", error);
      setErrorMessage(
        error.message || "Đã xảy ra lỗi khi gửi phản hồi. Vui lòng thử lại."
      );
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  // --- Updated Styles ---
  const styles = {
    form: {
      border: "1px solid #ccc",
      padding: "20px",
      borderRadius: "8px",
      maxWidth: "750px", // Increased width
      width: "90%", // Make it responsive on smaller screens within the modal
      margin: "20px auto",
      backgroundColor: "#f9f9f9",
      maxHeight: "90vh", // Prevent form from being too tall
      overflowY: "auto", // Allow scrolling within the form itself if needed
      boxSizing: "border-box",
    },
    label: { display: "block", marginBottom: "5px", fontWeight: "bold" },
    // Removed input, select styles as they are no longer used directly
    textarea: {
      width: "100%",
      padding: "10px", // Slightly larger padding
      marginBottom: "15px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      minHeight: "150px", // Increased min height for content
      boxSizing: "border-box",
      fontSize: "1rem",
    },
    button: {
      padding: "10px 20px",
      backgroundColor: "#007bff",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      marginRight: "10px",
      fontSize: "1rem",
    },
    buttonDisabled: { backgroundColor: "#ccc", cursor: "not-allowed" },
    closeButton: { backgroundColor: "#6c757d" },
    // fileInput: { marginBottom: "15px" }, // Commented out file input style
    statusMessage: { marginTop: "15px", padding: "10px", borderRadius: "4px" },
    successMessage: {
      backgroundColor: "#d4edda",
      color: "#155724",
      border: "1px solid #c3e6cb",
    },
    errorMessage: {
      backgroundColor: "#f8d7da",
      color: "#721c24",
      border: "1px solid #f5c6cb",
    },
    // --- New Styles for Rating ---
    ratingContainer: {
      marginBottom: "20px",
      display: "flex",
      alignItems: "center",
      gap: "10px", // Space between label and stars
    },
    starButton: {
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: "2px", // Adjust padding around star
      color: "#ccc", // Default star color (inactive)
      fontSize: "1.8rem", // Star size
      lineHeight: "1", // Prevent extra space below icon
    },
    starButtonActive: {
      color: "#ffc107", // Active star color (gold)
    },
  };

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      <h2>Gửi Phản Hồi</h2>

      {submitStatus === "success" && (
        <div style={{ ...styles.statusMessage, ...styles.successMessage }}>
          Cảm ơn bạn đã gửi phản hồi! AutoWork luôn ghi nhận mọi ý kiến đóng góp
          và sẽ nỗ lực cải tiến sản phẩm để mang lại trải nghiệm ngày càng tốt
          hơn.
        </div>
      )}
      {submitStatus === "error" && (
        <div style={{ ...styles.statusMessage, ...styles.errorMessage }}>
          Lỗi: {errorMessage}
        </div>
      )}

      {submitStatus !== "success" && (
        <>
          {/* --- Star Rating --- */}
          <div style={styles.ratingContainer}>
            <label style={{ ...styles.label, marginBottom: 0 }}>
              Đánh giá của bạn:
            </label>
            <div>
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button" // Important: prevent form submission
                  style={{
                    ...styles.starButton,
                    ...(star <= rating ? styles.starButtonActive : {}),
                  }}
                  onClick={() => setRating(star)}
                  disabled={isSubmitting}
                  aria-label={`Rate ${star} out of 5 stars`}
                >
                  {/* Use fill attribute for solid stars */}
                  <FiStar fill={star <= rating ? "currentColor" : "none"} />
                </button>
              ))}
            </div>
          </div>

          {/* --- Unified Content Textarea --- */}
          <label htmlFor="content" style={styles.label}>
            Nội dung phản hồi:
          </label>
          <textarea
            id="content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            style={styles.textarea}
            placeholder="Nhập góp ý, báo cáo lỗi (kèm các bước tái hiện nếu có), hoặc đề xuất tính năng mới..."
            disabled={isSubmitting}
            required
          />

          {/* --- Optional Attachment (Commented Out) --- */}
          {/*
          <label htmlFor="attachment" style={styles.label}>
            Đính Kèm Ảnh/Video (Tùy chọn):
          </label>
          <input
            type="file"
            id="attachment"
            onChange={handleFileChange}
            style={styles.fileInput}
            disabled={isSubmitting}
            accept="image/*,video/*"
          />
          {attachment && <p>Đã chọn: {attachment.name}</p>}
          */}

          {/* --- Submit/Close Buttons --- */}
          <div>
            <button
              type="submit"
              disabled={isSubmitting}
              style={
                isSubmitting
                  ? { ...styles.button, ...styles.buttonDisabled }
                  : styles.button
              }
            >
              {isSubmitting ? "Đang gửi..." : "Gửi Phản Hồi"}
            </button>
            {typeof onClose === "function" && (
              <button
                type="button"
                onClick={onClose}
                style={{ ...styles.button, ...styles.closeButton }}
                disabled={isSubmitting}
              >
                Đóng
              </button>
            )}
          </div>
        </>
      )}
      {/* --- Close button after success --- */}
      {submitStatus === "success" && typeof onClose === "function" && (
        <button
          type="button"
          onClick={onClose}
          style={{ ...styles.button, ...styles.closeButton, marginTop: "15px" }}
        >
          Đóng
        </button>
      )}
    </form>
  );
};

export default FeedbackForm;
